<template>
	<div ref="parentSidebar" class="vx-row">
		<vs-sidebar
			v-if="isSidebarGenerativeRepeat"
			click-not-close
			position-right
			default-index="1"
			color="primary"
			class="add-sidebar--repeat items-no-padding"
			style="z-index: 56000"
			v-model="isSidebarGenerativeRepeat"
		>
			<vx-card :cardBorder="true" :noShadow="true">
				<div class="flex justify-between items-center">
					<h5>{{ activeTab === 0 ? $t("PickupPoints") : $t("DeliveryPoints") }}</h5>
					<feather-icon
						icon="XIcon"
						class="cursor-pointer bg-primary text-white rounded-full font-bold"
						@click.stop="isSidebarGenerativeRepeat = false"
					></feather-icon>
				</div>
				<vs-divider />
				<vue-perfect-scrollbar class="scroll-area--form" :settings="settingsForm">
					<div class="vx-row">
						<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
							<label class="vs-input--label">{{ $t("Routing.Table.Identification") }}</label>
							<vs-input
								class="w-full"
								v-model="dataObject.identification"
								v-validate="'required'"
								name="identification"
								:disabled="true"
							/>
						</div>
						<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
							<label class="vs-input--label">{{ $t("IdentificationOfOrigin") }}</label>
							<vs-input
								class="w-full"
								v-model="dataObject.original_identification"
								name="original_identification"
								:disabled="true"
							/>
						</div>
					</div>
					<div class="vx-row mt-2">
						<div class="vx-col w-full">
							<vx-card
								:cardBorder="true"
								:noShadow="true"
								:title="isSidebarCalendar ? $t('TimeWindow.Schedule') : $t('RepeatFormat')"
							>
								<template slot="actions">
									<vs-button
										v-if="isSidebarCalendar"
										class="font-bold"
										color="primary"
										type="flat"
										icon-pack="feather"
										icon="icon-chevrons-left"
										@click.prevent="isSidebarCalendar = false"
										>{{ $t("Back") }}
									</vs-button>
									<vs-button
										v-else
										class="ml-2 mr-2 font-bold"
										color="primary"
										type="flat"
										icon-pack="feather"
										icon="icon-calendar"
										@click.prevent="isSidebarCalendar = true"
										>{{ $t("TimeWindow.Schedule") }}
									</vs-button>
								</template>
								<form data-vv-scope="create-visit-point">
									<div class="vx-row">
										<div class="vx-col w-full">
											<repeat-cron
												v-show="!isSidebarCalendar"
												@updateCronExpressionEmit="getCronExpression"
											/>
											<time-calendar
												v-if="isSidebarCalendar"
												ref="repeatCalendar"
												class="px-2"
												:viewData="true"
												:isMaximize="false"
												:cronExpression="cronExpression"
												:duration="
													getDaysInRange(
														{
															startDate: time_window.init_date,
															endDate: time_window.end_date,
														},
														{
															start: time_window.init_hour,
															end: time_window.end_hour,
														}
													)
												"
											/>
										</div>
									</div>
								</form>
							</vx-card>
							<vx-card
								class="mt-2"
								:cardBorder="true"
								:noShadow="true"
								:title="$t('TimeWindow.TimeWindow')"
							>
								<repeat-time-windows :time-window.sync="time_window" />
							</vx-card>
						</div>
					</div>
				</vue-perfect-scrollbar>
				<div class="vx-row">
					<div class="vx-col w-full">
						<div class="flex flex-wrap items-center justify-end py-2">
							<vs-button class="ml-4" @click.prevent="assigVisitPoint()">{{
								$t("VisitPoints.Assig")
							}}</vs-button>
						</div>
					</div>
				</div>
			</vx-card>
		</vs-sidebar>
		<vs-sidebar
			v-if="isSidebarDetailsRepeat"
			click-not-close
			position-right
			default-index="1"
			color="primary"
			class="add-sidebar--repeat items-no-padding"
			style="z-index: 56000"
			v-model="isSidebarDetailsRepeat"
		>
			<vx-card :cardBorder="true" :noShadow="true">
				<div class="flex justify-between items-center">
					<h5>{{ activeTab === 0 ? $t("PickupPoints") : $t("DeliveryPoints") }}</h5>
					<feather-icon
						icon="XIcon"
						class="cursor-pointer bg-primary text-white rounded-full font-bold"
						@click.stop="isSidebarDetailsRepeat = false"
					></feather-icon>
				</div>
				<vs-divider />
				<vue-perfect-scrollbar class="scroll-area--form" :settings="settingsForm">
					<detail-format-repeat :object-detail="dataObject" />
				</vue-perfect-scrollbar>
				<div class="vx-row">
					<div class="vx-col w-full">
						<div class="flex flex-wrap items-center justify-end py-2">
							<vs-button color="danger" class="ml-4" @click.prevent="deleteAssig()">{{
								$t("DeleteAssignment")
							}}</vs-button>
						</div>
					</div>
				</div>
			</vx-card>
		</vs-sidebar>
		<div class="vx-col w-full">
			<vx-card no-shadow card-border>
				<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner" color="success">
					<vs-tab :label="$t('PickUpService')">
						<div v-if="tempPickupPoints.length > 0" class="vx-col w-full lg:block mt-2 pr-1">
							<div class="flex items-center justify-end">
								<template>
									<vs-dropdown vs-trigger-click class="cursor-pointer">
										<div
											class="p-3 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
										>
											<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
											<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
										</div>
										<vs-dropdown-menu style="z-index: 54000">
											<vs-dropdown-item @click="setSearchField('Identification')">
												<span>{{ $t("ResourceModule.Table.Identification") }}</span>
											</vs-dropdown-item>
											<vs-dropdown-item @click="setSearchField('GroupSearch')">
												<span>{{ $t("GroupSearch") }}</span>
											</vs-dropdown-item>
										</vs-dropdown-menu>
									</vs-dropdown>
								</template>
								<vs-input
									v-model="searchQueryPickup"
									icon="icon-search"
									icon-pack="feather"
									class="w-full md:w-1/2"
									:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
								/>
							</div>
							<div class="flex justify-end items-center pr-1 mt-4">
								<vs-button
									class="mr-2"
									color="primary"
									type="border"
									icon-pack="feather"
									:title="$t('RouterSelection.CheckedAll')"
									icon="icon-check-square"
									@click.prevent="toggleSelectAllPickups()"
								></vs-button>
								<vs-button
									class="mr-2"
									color="primary"
									type="border"
									icon-pack="feather"
									:title="isExpandedPickup ? $t('CollapseEverything') : $t('ExpandAll')"
									:icon="isExpandedPickup ? 'icon-minimize-2' : 'icon-maximize-2'"
									@click.prevent="toggleAllPickup"
								></vs-button>
							</div>
						</div>
						<vue-perfect-scrollbar class="scroll-area" :settings="settings">
							<ListSelectedVisitPointsItemPickup
								ref="ListVisitPointsItemPickup"
								:visit_point_selected="getVisitPointPickupList"
								:activeTabProp="activeTab"
								:searchQueryPickup="searchQueryPickup"
								:showActions="false"
								:showChecked="true"
								:componentParent="'GENERATE_REPEAT_PICKUP'"
								:key="renderComponent"
								@getExpanded="getExpandedPickup"
								@isSidebarRepeat="getSidebarRepeat"
								@isSidebarDetailRepeat="getSidebarDetailRepeat"
								@visitPointPickup="getVisitPointPickup"
							></ListSelectedVisitPointsItemPickup>
						</vue-perfect-scrollbar>
					</vs-tab>
					<vs-tab :label="$t('DeliveryService')">
						<div v-if="tempDeliveryPoints.length > 0" class="vx-col w-full lg:block mt-4">
							<div class="flex flex-wrap items-center justify-end">
								<template>
									<vs-dropdown vs-trigger-click class="cursor-pointer">
										<div
											class="p-3 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
										>
											<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
											<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
										</div>
										<vs-dropdown-menu style="z-index: 54000">
											<vs-dropdown-item @click="setSearchField('Identification')">
												<span>{{ $t("ResourceModule.Table.Identification") }}</span>
											</vs-dropdown-item>
											<vs-dropdown-item @click="setSearchField('GroupSearch')">
												<span>{{ $t("GroupSearch") }}</span>
											</vs-dropdown-item>
										</vs-dropdown-menu>
									</vs-dropdown>
								</template>
								<vs-input
									v-model="searchQueryDelivery"
									icon="icon-search"
									icon-pack="feather"
									class="w-full md:w-1/2"
									:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
								/>
							</div>
							<div class="flex justify-end items-center pr-1 mt-4">
								<vs-button
									class="mr-2"
									color="primary"
									type="border"
									icon-pack="feather"
									:title="$t('RouterSelection.CheckedAll')"
									icon="icon-check-square"
									@click.prevent="toggleSelectAllDelivery()"
								></vs-button>
								<vs-button
									class="mr-2"
									color="primary"
									type="border"
									icon-pack="feather"
									:title="isExpandedDelivery ? $t('CollapseEverything') : $t('ExpandAll')"
									:icon="isExpandedDelivery ? 'icon-minimize-2' : 'icon-maximize-2'"
									@click.prevent="toggleAllDelivery"
								></vs-button>
							</div>
						</div>
						<vue-perfect-scrollbar class="scroll-area" :settings="settings">
							<ListSelectedVisitPointsItemDelivery
								ref="ListVisitPointsItemDelivery"
								:visit_point_selected_delivery="getVisitPointDeliveryList"
								:activeTabProp="activeTab"
								:searchQueryDelivery="searchQueryDelivery"
								:showActions="false"
								:showChecked="true"
								:componentParent="'GENERATE_REPEAT_DELIVERY'"
								:key="renderComponent"
								@getExpanded="getExpandedDelivery"
								@isSidebarRepeat="getSidebarRepeat"
								@isSidebarDetailRepeat="getSidebarDetailRepeat"
								@visitPointDelivery="getVisitPointDelivery"
							></ListSelectedVisitPointsItemDelivery>
						</vue-perfect-scrollbar>
					</vs-tab>
					<vs-tab :label="$t('Vehicles.Vehicles')">
						<div v-if="tempVehicles.length > 0" class="vx-col w-full lg:block mt-4 mb-2">
							<div class="flex items-center justify-end">
								<template>
									<vs-dropdown vs-trigger-click class="cursor-pointer">
										<div
											class="p-3 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
										>
											<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
											<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
										</div>
										<vs-dropdown-menu style="z-index: 54000">
											<vs-dropdown-item @click="setSearchField('Identification')">
												<span>{{ $t("ResourceModule.Table.Identification") }}</span>
											</vs-dropdown-item>
											<vs-dropdown-item @click="setSearchField('GroupSearch')">
												<span>{{ $t("GroupSearch") }}</span>
											</vs-dropdown-item>
										</vs-dropdown-menu>
									</vs-dropdown>
								</template>
								<vs-input
									v-model="searchQueryVehicle"
									icon="icon-search"
									icon-pack="feather"
									class="w-full md:w-1/2"
									:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
								/>
							</div>
							<div class="flex justify-end items-center pr-1 mt-4">
								<vs-button
									class="mr-2"
									color="primary"
									type="border"
									icon-pack="feather"
									:title="$t('RouterSelection.CheckedAll')"
									icon="icon-check-square"
									@click.prevent="toggleSelectAllVehicle()"
								></vs-button>
								<vs-button
									class="mr-2"
									color="primary"
									type="border"
									icon-pack="feather"
									:title="isExpandedVehicle ? $t('CollapseEverything') : $t('ExpandAll')"
									:icon="isExpandedVehicle ? 'icon-minimize-2' : 'icon-maximize-2'"
									@click.prevent="toggleAllVehicle"
								></vs-button>
							</div>
						</div>
						<vue-perfect-scrollbar class="scroll-area" :settings="settings">
							<list-selected-item-vehicle
								ref="listItemVehicle"
								:resourceList="getVehicleList"
								:searchQueryVehicle="searchQueryVehicle"
								:componentParent="'GENERATE_REPEAT_VEHICLE'"
								:showActions="false"
								:key="renderComponent"
								@getExpanded="getExpandedVehicle"
								@isSidebarRepeat="getSidebarRepeat"
								@isSidebarDetailRepeat="getSidebarDetailRepeat"
								@vehicleObjectEmit="getVehicle"
							/>
						</vue-perfect-scrollbar>
					</vs-tab>
				</vs-tabs>
			</vx-card>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DateUtils from "@/helpers/DateUtils.js";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import ListSelectedVisitPointsItemPickup from "@/components/optimization/visit-point/ListSelectedVisitPointsItemPickup.vue";
import ListSelectedVisitPointsItemDelivery from "@/components/optimization/visit-point/ListSelectedVisitPointsItemDelivery.vue";
import RepeatCron from "@/components/optimization/generate-repeat/RepeatCron.vue";
import RepeatTimeWindows from "@/components/optimization/generate-repeat/RepeatTimeWindows.vue";
import ListSelectedItemVehicle from "@/components/optimization/resource/ListSelectedItemVehicle.vue";
import DetailFormatRepeat from "@/components/optimization/generate-repeat/DetailFormatRepeat.vue";
import TimeCalendar from "@/components/shared/TimeCalendar.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export default {
	name: "GenerateRepeatItems",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		VuePerfectScrollbar,
		ListSelectedVisitPointsItemPickup,
		ListSelectedVisitPointsItemDelivery,
		RepeatTimeWindows,
		RepeatCron,
		ListSelectedItemVehicle,
		DetailFormatRepeat,
		TimeCalendar,
	},
	props: {
		activeTabRepeat: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			searchQueryPickup: null,
			searchQueryDelivery: null,
			searchQueryVehicle: null,
			searchFieldShipping: "Identification",
			isExpandedPickup: false,
			isExpandedDelivery: false,
			isExpandedVehicle: false,
			isSidebarGenerativeRepeat: false,
			isSidebarDetailsRepeat: false,
			isSidebarCalendar: false,
			tempPickupPoints: [],
			tempDeliveryPoints: [],
			tempVehicles: [],
			visitPointPickup: null,
			visitPointDelivery: null,
			vehicleObject: null,
			activeTab: this.activeTabRepeat,
			cronExpression: "",
			renderComponent: 0,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			settingsForm: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			time_window: {
				init_date: "",
				end_date: "",
				init_hour: "",
				end_hour: "",
			},
		};
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
	mounted() {
		// Inicializa los puntos de visitas y vehiculos cuando se monta el componente
		this.resetTempPickupPoints();
		this.resetTempDeliveryPoints();
		this.resetTempVehicles();
		this.time_window = {
			init_date: moment(
				this.$store.state.moduleOptimization.standardInputList["global_config"].init_date
			).format(),
			end_date: moment(this.$store.state.moduleOptimization.standardInputList["global_config"].end_date).format(),
			init_hour: this.$store.state.moduleOptimization.standardInputList["global_config"].init_hour,
			end_hour: this.$store.state.moduleOptimization.standardInputList["global_config"].end_hour,
		};
	},
	watch: {
		tempPickupPoints: {
			handler(newVal) {
				this.$emit("updatePickupPoints", newVal);
			},
			deep: true,
		},
		tempDeliveryPoints: {
			handler(newVal) {
				this.$emit("updateDeliveryPoints", newVal);
			},
			deep: true,
		},
		tempVehicles: {
			handler(newVal) {
				this.$emit("updateVehicles", newVal);
			},
			deep: true,
		},
	},
	computed: {
		visit_point_selected_pickup() {
			return this.$store.state.moduleOptimization.standardInputList["pickups"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["pickups"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["pickups"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["pickups"];
		},
		visit_point_selected_delivery() {
			return this.$store.state.moduleOptimization.standardInputList["deliveries"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["deliveries"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["deliveries"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["deliveries"];
		},
		vehiclesList() {
			return this.$store.state.moduleOptimization.standardInputList["vehicles"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["vehicles"];
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		getVisitPointPickupList() {
			return this.getFilteredList(this.tempPickupPoints, this.searchQueryPickup, this.searchFieldShipping);
		},
		getVisitPointDeliveryList() {
			return this.getFilteredList(this.tempDeliveryPoints, this.searchQueryDelivery, this.searchFieldShipping);
		},
		getVehicleList() {
			return this.getFilteredList(this.tempVehicles, this.searchQueryVehicle, this.searchFieldShipping);
		},
		searchSelected() {
			return this.$t(`${this.searchFieldShipping}`);
		},
		allSelectedPickup() {
			// Verifica si todos los puntos de visita en el array temporal están seleccionados
			return this.tempPickupPoints.every((point) => point.checked);
		},
		allSelectedDelivery() {
			// Verifica si todos los puntos de visita en el array temporal están seleccionados
			return this.tempDeliveryPoints.every((point) => point.checked);
		},
		allSelectedVehicle() {
			// Verifica si todos los puntos de visita en el array temporal están seleccionados
			return this.tempVehicles.every((vehicle) => vehicle.checked);
		},
		dataObject() {
			let data;
			if (this.activeTab === 0) {
				data = this.visitPointPickup;
			} else if (this.activeTab === 1) {
				data = this.visitPointDelivery;
			} else if (this.activeTab === 2) {
				data = this.vehicleObject;
			} else {
				data = null;
			}
			return data;
		},
	},
	methods: {
		setSearchField(val) {
			this.searchFieldShipping = val;
		},
		// Metodo auxiliar para agrupar elementos por 'original_identification'
		groupByOriginalIdentification(items) {
			return items.reduce((acc, item) => {
				const key = item.original_identification;
				if (!acc[key]) {
					acc[key] = [];
				}
				acc[key].push(item);
				return acc;
			}, {});
		},
		// Método generalizado para búsqueda y filtrado
		getFilteredList(items, searchQuery, searchField) {
			const groupedItems = this.groupByOriginalIdentification(items);
			if (!searchQuery || searchQuery.trim() === "") {
				return Object.entries(groupedItems);
			}
			const normalizedSearchQuery = searchQuery.trim().toLowerCase();
			const searchList = Object.entries(groupedItems).reduce((acc, [key, items]) => {
				let filteredItems;

				if (searchField === "Identification") {
					filteredItems = items.filter((item) =>
						item.identification.toLowerCase().includes(normalizedSearchQuery)
					);
					if (filteredItems.length) {
						acc.push([key, filteredItems]);
					}
				} else if (key.toString().toLowerCase().includes(normalizedSearchQuery)) {
					acc.push([key, items]);
				}
				return acc;
			}, []);
			if (searchList.length > 0) {
				this.handleToggle(this.activeTab);
			}
			return searchList;
		},
		handleToggle(activeTab) {
			if (activeTab === 0 && !this.isExpandedPickup) this.toggleAllPickup();
			else if (activeTab === 1 && !this.isExpandedDelivery) this.toggleAllDelivery();
			else if (activeTab === 2 && !this.isExpandedVehicle) this.toggleAllVehicle();
		},
		toggleAllPickup() {
			this.$refs.ListVisitPointsItemPickup.toggleAll();
		},
		toggleAllDelivery() {
			this.$refs.ListVisitPointsItemDelivery.toggleAll();
		},
		toggleAllVehicle() {
			this.$refs.listItemVehicle.toggleAll();
		},
		getExpandedPickup(val) {
			this.isExpandedPickup = val;
		},
		getExpandedDelivery(val) {
			this.isExpandedDelivery = val;
		},
		getExpandedVehicle(val) {
			this.isExpandedVehicle = val;
		},
		getSidebarRepeat(val) {
			this.isSidebarGenerativeRepeat = val;
		},
		getSidebarDetailRepeat(val) {
			this.isSidebarDetailsRepeat = val;
		},
		getVisitPointPickup(val) {
			this.visitPointPickup = val;
		},
		getVisitPointDelivery(val) {
			this.visitPointDelivery = val;
		},
		getVehicle(val) {
			this.vehicleObject = val;
		},
		resetTempPickupPoints() {
			// Copia el array original a tempPickupPoints para trabajar sin modificar el original
			this.tempPickupPoints = this.visit_point_selected_pickup.map((point) => ({...point, checked: false}));
		},
		toggleSelectAllPickups() {
			// Alterna la selección de todos los puntos en el array temporal
			const newValue = !this.allSelectedPickup;
			this.tempPickupPoints.forEach((point) => (point.checked = newValue));
		},
		resetTempDeliveryPoints() {
			// Copia el array original a tempDeliveryPoints para trabajar sin modificar el original
			this.tempDeliveryPoints = this.visit_point_selected_delivery.map((point) => ({...point, checked: false}));
		},
		toggleSelectAllDelivery() {
			// Alterna la selección de todos los puntos en el array temporal
			const newValue = !this.allSelectedDelivery;
			this.tempDeliveryPoints.forEach((point) => (point.checked = newValue));
		},
		resetTempVehicles() {
			// Copia el array original a tempVehicles para trabajar sin modificar el original
			this.tempVehicles = this.vehiclesList.map((vehicle) => ({...vehicle, checked: false}));
		},
		toggleSelectAllVehicle() {
			// Alterna la selección de todos los puntos en el array temporal
			const newValue = !this.allSelectedVehicle;
			this.tempVehicles.forEach((vehicle) => (vehicle.checked = newValue));
		},
		getCronExpression(cron) {
			this.cronExpression = cron;
		},
		assigVisitPoint() {
			this.time_window.init_date = DateUtils.toDefaultDateTime(this.time_window.init_date, "YYYY-MM-DD");
			this.time_window.end_date = DateUtils.toDefaultDateTime(this.time_window.end_date, "YYYY-MM-DD");
			const updateData = (list, target, eventName) => {
				const item = list.find((el) => el.identification === target.identification);
				if (item) {
					Object.assign(item, {cron: this.cronExpression, time_window_repeat: this.time_window});
				}
				this.$emit(eventName, list);
				this.isSidebarGenerativeRepeat = false;
			};
			switch (this.activeTab) {
				case 0:
					updateData(this.tempPickupPoints, this.visitPointPickup, "updatePickupPoints");
					break;
				case 1:
					updateData(this.tempDeliveryPoints, this.visitPointDelivery, "updateDeliveryPoints");
					break;
				case 2:
					updateData(this.tempVehicles, this.vehicleObject, "updateVehicles");
					break;
			}
			this.renderComponent++;
		},
		deleteAssig() {
			const updateData = (list, target, eventName) => {
				delete target["cron"];
				delete target["time_window_repeat"];
				this.$emit(eventName, list);
				this.isSidebarDetailsRepeat = false;
			};
			switch (this.activeTab) {
				case 0:
					updateData(this.tempPickupPoints, this.visitPointPickup, "updatePickupPoints");
					break;
				case 1:
					updateData(this.tempDeliveryPoints, this.visitPointDelivery, "updateDeliveryPoints");
					break;
				case 2:
					updateData(this.tempVehicles, this.vehicleObject, "updateVehicles");
					break;
			}
			this.renderComponent++;
		},
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 410px;
	max-height: 360px;
}

.scroll-area--form {
	margin: auto;
	width: 100%;
	min-height: 490px;
	max-height: 450px;
}

.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
.is-stuck {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 80px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.is-stuck--datarutas {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 60px);
	z-index: 14;
}
.color-logo {
	color: rgba(35, 39, 133, 1);
}
.add-sidebar--repeat {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 50vw;
		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
.add-sidebar--calendar {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 50vw;
		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
</style>
